import { get } from '@helpcenter/ajax';
import type { Observable } from '@helpcenter/epics-rxjs';
import { isNil, pickBy } from 'lodash';
import * as qs from 'query-string';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { PortalSearchResponse } from './types';

interface PortalsQuery {
	query: string;
	limit: number;
	excludedPortalId?: number | null;
}

export const searchPortals = (portalsQuery: PortalsQuery): Observable<PortalSearchResponse[]> => {
	const sanitizedQuery = pickBy(portalsQuery, (prop) => !isNil(prop));
	const queryString = qs.stringify(sanitizedQuery);

	return get(`${contextPath}/rest/servicedesk/search/1/search/portals?${queryString}`).map(
		(ajaxResponse) => {
			// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			return ajaxResponse.response.portals as PortalSearchResponse[];
		},
	);
};
